module.exports = __webpack_public_path__ + "static/ocean-beach@fiferries.b3ff0900.jpg";